<template>
  <div class="loginBg" @keyup.enter="handleSubmit" style=''>
    <div class="loginHeader">
      <el-row style="padding-top: 20px;margin-left: 10%">
        <el-col :span="20">
          <img src="../assets/images/logoLogin.png" class="logo" @click="openLicenseDialog">
          <span class="logoTxt">
            {{ $t('lin_global.logoTitle') }}
          </span>
        </el-col>
      </el-row>
    </div>
    <div class="blue"></div>
    <div class="card-box">
      <el-form id="form-box" :model="loginForm" :rules="loginRules" ref="loginForm" class="demo-ruleForm loginform">
        <h3 class="title">{{ $t('lin_global.yhdl') }}</h3>

        <el-form-item prop="lang" style="margin: 0 auto;width: 80%">

          <!-- <el-select @change="langEvent" v-model="value" style="width: 100%;margin-top:20px;border:none;float:left;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
            <span v-bind:class="item.style"></span>
          </el-option>
        </el-select> -->

          <el-input placeholder="" readonly v-model="langName" class="input-with-select" style="margin-top:20px;">

            <el-dropdown trigger="click" slot="append" placement='bottom-end' @command='langchange'>
              <span class="el-dropdown-link">
                <img :src='langUrl' style="width:24px;height:16px;margin-top:5px;" />
                <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for='(item,index) in langs' :key="index" :command='item.value'><img :src='item.url'
                    style='width:24px;' /> &nbsp;{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-input>



        </el-form-item>
        <el-form-item prop="account" style="margin: 0 auto;width: 80%">
          <el-input type="text" class="loginInput" v-model="loginForm.account" auto-complete="off"
            :placeholder="$t('lin_global.zh')"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass" style="margin: 0 auto;width: 80%">
          <el-input type="password" @change='pswChange' class="loginInput" v-model="loginForm.checkPass"
            auto-complete="off" :placeholder="$t('lin_global.password')"></el-input>
        </el-form-item>
        <el-form-item prop="code" style="margin: 0 auto;width: 80%">
          <el-row style="">
            <el-col :span='12'>
              <el-input class="loginInput" v-model="loginForm.code" auto-complete="off"
                :placeholder="$t('app_ckcode')"></el-input>
            </el-col>
            <el-col :span='12'>
              <!-- <div @click='changeCP' style="position:absolute;width: 50%;height:100%;z-index:100;"></div>
            <iframe id='cciframe' frameborder="0" scrolling="no" style="position:absolute; bottom:0;right: 0;padding:0px;margin:0;" width="120px" height="40px;" :src='$cpLink'></iframe> -->
              <!-- <mcheckcode :data='cdata' style="position:absolute; bottom:-14px;right: 0;"></mcheckcode> -->
              <img @click="recode" :src="codeObj ? codeObj.code : ''"
                style="position:absolute; bottom:0;right: 0;width: 110px;height: 40px;" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-checkbox v-model="checked" style="margin:30px 0px 20px 10%;color: #979797;">{{ $t('lin_global.jzmm')
          }}</el-checkbox>
        <el-form-item style="width:80%;margin:0 auto">
          <el-button type="primary" v-on:click="handleSubmit"
            style="width:100%;background-image: linear-gradient(-90deg, #158EE9 0%, #2CACFD 100%);border-radius: 2px;"
            :loading="logining">{{ $t('lin_global.login') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      {{ $t('lin_global.bah') }}
      <el-popover ref="popover1" placement="top-start" :title="$t('app_verUdCt')" width="200" trigger="hover">
        <!-- <pre>/n/r{{verTip}}</pre> -->
        <!-- <pre>{{verTip}}</pre> -->
        <div id="markdownBody" v-html='verTip'></div>
      </el-popover>

      <el-button style='border:none;background:none;color:#979797;' v-popover:popover1>v{{ version }}</el-button>

      <el-dialog cclass="gDia" v-loading="logining" @close="closeDia" title="Activate TMS" v-model="isauth"
        size="small">
        <el-form :model="aform" rrules="rules2" ref="aform">
          <el-form-item label="TMS is active until:" :label-width="formLabelWidth">
            <el-row>
              <el-col :span="24">
                <div style="text-align:left;">{{ aform.date }}</div>
              </el-col>
              <el-col :span="24" style="text-align:left;">
                Please contact the administrator to request a new activation code
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="userName" :label-width="formLabelWidth">
            <el-input v-model="aform.usr"></el-input>
          </el-form-item>
          <el-form-item label="password" :label-width="formLabelWidth">
            <el-input @change="authPswChange" v-model="aform.psw" type="password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="code" :label-width="formLabelWidth" prop="pass">
            <el-input type="textarea" rows='5' v-model="aform.code"></el-input>

          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDia">Cancel</el-button>
          <el-button type="primary" @click="submitForm('aform')">Activate</el-button>
        </div>
      </el-dialog>

      <el-dialog cclass="gDia" v-loading="logining" @close="closeDiaCk" ttitle="$t('app_mulfcau')" v-model="ischeck"
        size="small">
        <div id="mfauthfr">
          <!-- fa-shield   fa-get-pocket  -->
          <i class="fa fa-shield "></i>
          <h1>{{ $t('app_mulfcau') }}</h1>
          <el-input :placeholder="$t('app_opmfackip6dycode')" v-model="code6"></el-input>
          <h2>{{ $t('app_cantprvmcodectadm') }}</h2>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="codeCheck">{{ $t('app_verifc') }}</el-button>
        </div>
      </el-dialog>
    </div>


    <!-- 激活码 -->
    <el-dialog title="Enter License" :visible.sync="licenseDialogVisible" :close-on-click-modal="false"
      :show-close="false" width="400px">
      <el-form ref="licenseForm" :model="licenseForm" :rules="licenseRules" label-width="120px">
        <el-form-item label="MAC Address">
          <el-row>
            <el-col :span="16">
              <el-input v-model="macAddress" readonly placeholder="MAC Address will appear here"
                style="width: 100%;"></el-input>
            </el-col>
            <el-col :span="8" style="padding-left: 10px;">
              <el-button type="primary" @click="fetchMacAddress">Get MAC Address</el-button>
            </el-col>
          </el-row>
        </el-form-item>


        <el-form-item label="License Key" prop="licenseKey">
          <el-input type="textarea" :rows="5" v-model="licenseForm.licenseKey" autocomplete="off"
            placeholder="Enter your license key"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="activationLicense">Submit</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import JQuery from 'jquery'
import axios from 'axios'
import { baseurl } from '../api/url'
import Cookie from 'js-cookie'
axios.defaults.withCredentials = true;
var md5 = require('md5');
import JSEncrypt from 'jsencrypt'
import req from '../api/req.js'
// import mcheckcode from '@/components/global/mcheckcode'
export default {
  data() {
    return {
      licenseDialogVisible: false, // 控制弹框的可见性
      licenseForm: {
        licenseKey: ''
      },
      macAddress: '', // 存储获取到的 MAC 地址
      licenseRules: {
        licenseKey: [
          { required: true, message: 'Please input the license key', trigger: 'blur' }
        ]
      },
      tmpres: '',
      dld: false,
      code6: '',
      ischeck: false,
      formLabelWidth: '140px',
      isauth: false,
      aform: {
        usr: '',
        psw: '',
        code: '',
        igmd5: false,
        date: ''
      },
      codeObj: '',
      pbobj: '',
      langItem: {
        'zh_cn': { label: '中文', url: require('../assets/chinese.png') },
        'en': { label: 'English', url: require('../assets/english.png') },
        'ko': { label: '한국어', url: require('../assets/korea.png') },
        'ru': { label: 'русский ', url: require('../assets/russia.png') },
        // 'japan': {label: '日本語', url: require('../assets/jpan.png')},
      },
      langs: [
        {
          value: 'zh_cn',
          label: '中文',
          url: require('../assets/chinese.png')
        }, {
          value: 'en',
          label: 'English',
          url: require('../assets/english.png')
        },
        {
          value: 'ru',
          label: 'русский ',
          url: require('../assets/russia.png')
        },
        {
          value: 'ko',
          label: '한국어',
          url: require('../assets/korea.png')
        },
        // {
        //   value: 'japan',
        //   label: '日本語',
        //   url: require('../assets/jpan.png')
        // }
      ],
      options: [{
        value: 'zh_cn',
        label: this.$t('lin_global.china'),
        style: 'chinese'
      }, {
        value: 'en',
        label: this.$t('lin_global.english'),
        style: 'english'
      },
      {
        value: 'ru',
        label: this.$t('lin_global.russia'),
        style: 'russia'
      },
      {
        value: 'ko',
        label: this.$t('lin_global.korean'),
        style: 'korean'
      }],
      verTip: '',
      version: '',
      popover1: false,
      value: '',
      logining: false,
      loginForm: {
        account: '',
        checkPass: '',
        code: ''
      },
      loginRules: {
        account: [
          { required: true, message: this.$t('lin_global.qsrzh'), trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: this.$t('lin_global.qsrmm'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('app_plsip'), trigger: 'blur' }
        ]
      },
      checked: false
    }
  },
  components: {
    // mcheckcode
  },
  mounted: function () {

    this.recode()

    var heightWin = JQuery(window).height();
    JQuery('.loginBg').css("height", heightWin);

    this.$getPublicKey(res => {
      this.pbobj = res.data
    })

    this.$getVer((res) => {
      console.log(res)
      if (res.status == 200) {
        this.version = res.data.version
        this.verTip = res.data.memo
        if (res.data.date) {
          this.isauth = true
          var tmp = this.$getWObj().auth;
          this.aform = tmp ? tmp : this.aform
          this.aform.igmd5 = tmp ? true : false
          this.aform.date = res.data.date
        }
      } else {
        this.$message.error(this.$t('app_not_auth'))
        setTimeout(() => {
          this.licenseDialogVisible = true;
        }, 500);
      }
    }, () => {
      // error
      this.$message.error(this.$t('app_rqsError'))
      //this.licenseDialogVisible = true;
    })

    // remember
    if (localStorage.isRemember == 1) {
      this.loginForm.account = localStorage.rUsr
      this.loginForm.checkPass = localStorage.rPsw
      this.checked = localStorage.isRemember == 1 ? true : false
    }

  },
  created() {

    if (!localStorage.getItem("system_lang")) {
      this.value = "zh_cn";
      //req.common.changeLang(this.value);
    } else {
      this.value = localStorage.getItem("system_lang")
      //req.common.changeLang(this.value);
    }
  },
  computed: {
    langName() {
      return this.langItem[this.value].label
    },
    langUrl() {
      return this.langItem[this.value].url
    }
  },
  methods: {
    // 打开 License 弹框
    openLicenseDialog() {
      this.licenseDialogVisible = true;
    },
    activationLicense() {
      this.$activationLicense(this.licenseForm.licenseKey, (res) => {
        console.log(res)
        if (res.status == 200) {
          this.$message.success('successfully!');
          setTimeout(() => {
            this.licenseDialogVisible = false;
            this.$router.go(0);
          }, 500);
        } else {
          this.$message.error(res.message)
        }
      }, () => {
        // error
        this.$message.error(this.$t('app_rqsError'))
      })
    },
    // 模拟获取 MAC 地址
    async fetchMacAddress() {
      this.$fetchMacAddress((res) => {
        console.log(res)
        this.macAddress = res.data || 'Unable to fetch MAC address';
        this.$message.success('MAC Address fetched successfully!');
      }, () => {
        // error
        this.$message.error(this.$t('app_rqsError'))
      })
    },
    codeCheck() {
      if (!this.code6) {
        this.$message.error(this.$t('app_inputNumber'))
        return
      }
      this.dld = true
      this.$loginCodeCheck(this.tmpres.user.userid, this.code6, res => {
        this.dld = false
        if (res.status == 200) {
          this.closeDiaCk()
          localStorage.setItem('user', res.data.token)
          this.$router.push({ path: '/' })
        } else {
          this.$message.error(res.message)
        }
      }, () => {
        this.dld = false
      })
    },
    closeDiaCk() {
      this.ischeck = false
      this.code6 = ''
    },
    authPswChange() {
      this.aform.igmd5 = false
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var fm = this.aform
          this.logining = true
          this.$authLogin(fm.usr, fm.igmd5 ? fm.psw : md5(fm.psw), fm.code, res => {
            this.logining = false
            if (res.status == 200) {
              this.aform.psw = md5(fm.psw)
              this.aform.igmd5 = true
              this.$setWObj('auth', this.aform)
              this.closeDia()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.logining = false
          })
        } else {
          return false;
        }
      });
    },
    closeDia() {
      this.isauth = false

    },
    recode() {
      this.$getCheckcode(res => {
        this.codeObj = {}
        this.codeObj = res.data
      })
    },
    pswChange() {
      localStorage.rPsw = ''
      localStorage.isRemember = '0'
      localStorage.rUsr = ''
    },
    langchange(vl) {
      this.langEvent(vl)
    },
    langEvent(val) {
      localStorage.setItem("system_lang", val);
      req.common.changeLang(val);
      localStorage.setlang = '1'
      window.location.reload(true);
    },
    // 重组路由信息,因为有些字段需要更名
    resolvingRouterData(roleList = [], data = []) {
      function rcom(name) {
        return require(`@/components/${name}.vue`)
      }
      function ge(roleList, data) {
        data.forEach((item) => {
          let menu = Object.assign({}, item)
          menu.component = require(`@/components/${item.component}.vue`)
          if (!menu.meta) {
            menu.meta = {}
          }
          if (menu.superId !== 0) {
            menu.children = []
            if (item.children) {
              ge(menu.children, item.children)
            }
          }

          roleList.push(menu)
        })
      }

      ge(roleList, data)

    },
    // 获取用户拥有的权限
    getUserRoe(token) {
      var that = this
      axios.post(`${baseurl}/menu/menuList.do`, { token: token }).then(res => {
        if (res.data.status === 200) {
          var roleList = res.data.data;

          var rrr = []

          that.resolvingRouterData(rrr, roleList)


          that.$router.addRoutes(rrr)
          this.$store.dispatch('setRouters', rrr);
          Cookie.set("roleList", "success")

        }
      });
    },
    handleSubmit: function () {
      var that = this

      this.$refs['loginForm'].validate(function (result) {

        if (result) {
          // 验证通过

          // 执行登录操作 remember
          // genrsa

          // var password = localStorage.isRemember == 1 ? this.loginForm.checkPass : this.$sha256(this.loginForm.checkPass)
          var password = localStorage.isRemember == 1 ? this.loginForm.checkPass : md5(this.loginForm.checkPass)


          var timestamp = (new Date()).valueOf()
          // var pparam = {
          //   "userName": this.loginForm.account,
          //   "password": password,
          //   "code": this.loginForm.code,
          //   "loginTime": timestamp,
          //   "token": ''
          // }
          var pparam = {
            "password": password,
            "loginTime": timestamp,
          }
          var encrypt = new JSEncrypt()
          encrypt.setPublicKey(this.pbobj.publicKey)
          var encryptData = encrypt.encrypt(JSON.stringify(pparam))

          this.logining = true

          // var params = { userName: this.loginForm.account, password: password}
          var params = {
            "userName": this.loginForm.account,
            "random": this.pbobj.random,
            "content": encryptData,
            "token": '',
            "code": this.loginForm.code,
            "codeId": this.codeObj.codeId
          }

          axios.post(`${baseurl}/user/login.do`, params).then(res => {

            if (res.data.status !== 200) {
              this.$notify({
                title: this.$t('lin_global.error'),
                message: res.data.message,
                type: 'error'
              })
              this.logining = false
              this.recode()
              if (res.data.status == 600) this.isauth = true
            } else {

              localStorage.setItem('userId', res.data.user.userid)
              localStorage.setItem('mechanismId', res.data.user.mechanismId)
              localStorage.setItem('userType', res.data.user.userType)
              localStorage.setItem('logo', res.data.user.logoAddress)
              localStorage.setItem('cerType', res.data.user.cerType + '')
              this.$store.dispatch('setHomeLogo', localStorage.getItem('logo'))
              this.$cleanWObj() // 每次登录初始化缓存
              this.$setWObj('login', res.data.user)

              // location.hash = "#/"
              // 登录标识, 如果有该tag证明用户已经通过了登录接口进入的系统.
              localStorage.setItem('loginTag', new Date().getTime() + '')
              this.logining = false
              // remember
              localStorage.isRemember = this.checked ? 1 : 0
              if (this.checked) {
                localStorage.rUsr = this.loginForm.account
                localStorage.rPsw = password
              } else {
                localStorage.rUsr = ''
                localStorage.rPsw = ''
              }

              // mfa
              if (res.data.user.bindMfa == 1) {
                this.tmpres = res.data
                this.ischeck = true

              } else {
                localStorage.setItem('user', res.data.data)
                this.$router.push({ path: '/' })
              }

              // localStorage.setItem('user',res.data.data)
              // this.$router.push({ path: '/' })


            }
          })
          // 执行登录操作 end
        }
      }.bind(that));
    }
  }
}
</script>

<style scoped>
.blue {
  width: 100%;
  height: 2px;
  background-image: linear-gradient(-90deg, #158EE9 0%, #2CACFD 100%);
}

.card-box {

  background-clip: padding-box;
  width: 360px;
  box-sizing: border-box;
  position: absolute;
  top: 45%;
  left: 50%;
  margin-top: -200px;
  margin-left: -180px;
  height: 470px;
  background: #FFFFFF;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.10);
  border-radius: 4px;
}

/*.loginBg{
      width: 100%;
      background: url("../../static/img/light_wool.png") repeat;
      position: relative;
    }*/
.loginInput {
  border-color: #EDEDED;
  width: 100%;
  background: #FCFCFC;
  border-radius: 2px;
  margin: 0 auto;
  margin-top: 30px;
}

.card-box .el-input__inner {
  border-radius: 2px;
}

.title {
  text-align: center;
  background: #FCFCFC;
  height: 70px;
  line-height: 70px;
  color: #575757;
  font-size: 20px;
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 10px;
}

.loginform {
  width: 100%;

}

.el-tabs--border-card>.el-tabs__content {
  height: 223px;
}

.logoTxt {
  color: #4181DC;
}

.logo {
  height: 40px;
  float: left;
  border-right: 1px solid #D8D8D8;
  padding-right: 10px;
  margin-top: -10px;
}

.logoTxt {
  float: left;
  font-size: 20px;
  margin-left: 10px;
  margin-top: 2px;
}

.loginHeader {
  height: 60px;
  background: #fff;
  width: 100%;
}

.footer {
  font-size: 14px;
  color: #979797;
  text-align: center;
  position: absolute;
  left: 50%;
  width: 600px;
  bottom: 40px;
  margin-left: -300px;
}

#mfauthfr {
  text-align: left;
}

#mfauthfr i {
  font-size: 55px;
  color: rgb(51, 124, 109);
  vertical-align: middle;
}

#mfauthfr h1 {
  display: inline-block;
  font-size: 30px;
  vertical-align: middle;
}

#mfauthfr h2 {
  margin-top: 20px;
}

#mfauthfr .el-input {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// login.vue?1b2cb274